export const CURSOS_GRADUACAO = [
  "Acupuntura",
  "Administração",
  "Administração Pública",
  "Agrimensura",
  "Agrocomputação",
  "Agroecologia",
  "Agroindústria",
  "Agronegócio",
  "Agronomia",
  "Agropecuária",
  "Alimentos",
  "Antropologia",
  "Análise de Dados",
  "Análise e Desenvolvimento de Sistemas",
  "Apicultura e Meliponicultura",
  "Aquicultura",
  "Arqueologia",
  "Arquitetura de Dados",
  "Arquitetura e Urbanismo",
  "Arquivologia",
  "Artes",
  "Artes Cênicas",
  "Artes Plásticas",
  "Artes Visuais",
  "Artes do Espetáculo",
  "Artes e Mídias Digitais",
  "Assessoria Executiva Digital",
  "Astronomia",
  "Atividades de Inteligência e Gestão de Sigilos",
  "Auditoria em Saúde",
  "Automação Industrial",
  "Automação de Escritórios e Secretariado",
  "Automação e Manufatura Digital",
  "Banco de Dados",
  "Biblioteconomia",
  "Big Data e Inteligência Analítica",
  "Big Data no Agronegócio",
  "Biocombustíveis",
  "Bioenergia",
  "Bioinformática",
  "Biologia",
  "Biomedicina",
  "Bioquímica",
  "Biotecnologia",
  "Blockchain e Criptografia Digital",
  "Cafeicultura",
  "Canto",
  "Cenografia",
  "Cibersegurança",
  "Cinema e Audiovisual",
  "Ciência da Computação",
  "Ciência de Dados",
  "Ciências Agrícolas",
  "Ciências Atuariais",
  "Ciências Biológicas",
  "Ciências Contábeis",
  "Ciências Econômicas",
  "Ciências Exatas",
  "Ciências Sociais",
  "Ciências da Natureza",
  "Coach Digital",
  "Coaching e Mentoring",
  "Coding",
  "Composição e Regência",
  "Computação",
  "Computação e Robótica Educativa",
  "Computação em Nuvem",
  "Comunicação Assistiva",
  "Comunicação Digital",
  "Comunicação Institucional",
  "Comunicação Social",
  "Comunicação e Marketing",
  "Comunicação em Computação Gráfica",
  "Comunicação em Mídias Digitais",
  "Comércio Exterior",
  "Conservação e Restauro",
  "Construção Civil",
  "Construção Naval",
  "Construção de Edifícios",
  "Controle Ambiental",
  "Controle de Obras",
  "Cosmetologia e Estética",
  "Cozinha Contemporânea",
  "Dança",
  "Data Science",
  "Defesa Cibernética",
  "Defesa Médica Hospitalar",
  "Desenho Industrial",
  "Desenho de Animação",
  "Desenho e Plástica",
  "Desenvolvimento Back-End",
  "Desenvolvimento Mobile",
  "Desenvolvimento Regional",
  "Desenvolvimento Rural",
  "Desenvolvimento de Aplicativos para Dispositivos Móveis",
  "Desenvolvimento de Produtos Plásticos",
  "Desenvolvimento de Sistemas",
  "Desenvolvimento e Gestão de Startups",
  "Desenvolvimento para Internet",
  "Desenvolvimento para Web",
  "Design",
  "Design Comercial",
  "Design Digital",
  "Design Editorial",
  "Design Educacional",
  "Design Gráfico",
  "Design de Ambientes",
  "Design de Animação",
  "Design de Aplicações e Interfaces Digitais",
  "Design de Experiência e de Serviços",
  "Design de Games",
  "Design de Interiores",
  "Design de Moda",
  "Design de Produto",
  "Devops",
  "Digital Influencer",
  "Digital Security",
  "Direito",
  "Direção",
  "E-Commerce",
  "Educador Social",
  "Educação Especial",
  "Educação Física",
  "Educação do Campo",
  "Educação e Processos de Trabalho: Alimentação Escolar",
  "Eletrotécnica Industrial",
  "Eletrônica Automotiva",
  "Eletrônica Industrial",
  "Embelezamento e Imagem Pessoal",
  "Empreendedorismo",
  "Energias Renováveis",
  "Enfermagem",
  "Engenharia Acústica",
  "Engenharia Aeroespacial",
  "Engenharia Aeronáutica",
  "Engenharia Agroindustrial",
  "Engenharia Agronômica",
  "Engenharia Agrícola",
  "Engenharia Ambiental",
  "Engenharia Automotiva",
  "Engenharia Bioenergética",
  "Engenharia Biomédica",
  "Engenharia Bioquímica",
  "Engenharia Biotecnológica",
  "Engenharia Cartográfica",
  "Engenharia Civil",
  "Engenharia Eletrônica",
  "Engenharia Elétrica",
  "Engenharia Ferroviária e Metroviária",
  "Engenharia Florestal",
  "Engenharia Física",
  "Engenharia Geológica",
  "Engenharia Hídrica",
  "Engenharia Industrial",
  "Engenharia Mecatrônica",
  "Engenharia Mecânica",
  "Engenharia Metalúrgica",
  "Engenharia Naval",
  "Engenharia Química",
  "Engenharia Têxtil",
  "Engenharia da Computação",
  "Engenharia da Mobilidade",
  "Engenharia de Agrimensura",
  "Engenharia de Agronegócios",
  "Engenharia de Alimentos",
  "Engenharia de Aquicultura",
  "Engenharia de Automação",
  "Engenharia de Bioprocessos",
  "Engenharia de Biossistemas",
  "Engenharia de Biotecnologia",
  "Engenharia de Energia",
  "Engenharia de Gestão",
  "Engenharia de Informação",
  "Engenharia de Instrumentação, Automação e Robótica",
  "Engenharia de Manufatura",
  "Engenharia de Materiais",
  "Engenharia de Minas",
  "Engenharia de Pesca",
  "Engenharia de Petróleo",
  "Engenharia de Produção",
  "Engenharia de Recursos Hídricos",
  "Engenharia de Saúde e Segurança",
  "Engenharia de Serviços",
  "Engenharia de Sistemas",
  "Engenharia de Software",
  "Engenharia de Telecomunicações",
  "Engenharia de Transporte e Logística",
  "Engenharia em Sistemas Digitais",
  "Escrita Criativa",
  "Estatística",
  "Estilismo",
  "Estradas",
  "Estética e Cosmética",
  "Eventos",
  "Fabricação Mecânica",
  "Farmácia",
  "Filmmaker",
  "Filosofia",
  "Finanças, Blockchain e Criptomoedas",
  "Fisioterapia",
  "Fitoterapia",
  "Fonoaudiologia",
  "Fotografia",
  "Fruticultura",
  "Futebol",
  "Física",
  "Game Design",
  "Gastronomia",
  "Geografia",
  "Geologia",
  "Geoprocessamento",
  "Gerenciamento de Redes de Computadores",
  "Gerontologia",
  "Gestão Ambiental",
  "Gestão Comercial",
  "Gestão Cultural",
  "Gestão Desportiva e de Lazer",
  "Gestão Empresarial",
  "Gestão Financeira",
  "Gestão Hospitalar",
  "Gestão Portuária",
  "Gestão Pública",
  "Gestão Tributária",
  "Gestão da Avaliação",
  "Gestão da Inovação e Empreendedorismo Digital",
  "Gestão da Produção Industrial",
  "Gestão da Qualidade",
  "Gestão da Segurança Pública e Patrimonial",
  "Gestão da Tecnologia da Informação",
  "Gestão das Organizações do Terceiro Setor",
  "Gestão das Relações Eletrônicas",
  "Gestão de Agronegócios",
  "Gestão de Cidades Inteligentes",
  "Gestão de Cloud Computing",
  "Gestão de Cooperativas",
  "Gestão de Energia e Eficiência Energética",
  "Gestão de Equinocultura",
  "Gestão de Inventário Extrajudicial",
  "Gestão de Investimentos",
  "Gestão de Lojas e Pontos de Vendas",
  "Gestão de Mercado de Capitais",
  "Gestão de Micro e Pequenas Empresas",
  "Gestão de Negócios",
  "Gestão de Pessoas",
  "Gestão de Qualidade na Saúde",
  "Gestão de Recursos Humanos",
  "Gestão de Recursos Hídricos",
  "Gestão de Representação Comercial",
  "Gestão de Resíduos de Serviços de Saúde",
  "Gestão de Saúde Pública",
  "Gestão de Segurança Privada",
  "Gestão de Seguros",
  "Gestão de Serviços Judiciários e Notariais",
  "Gestão de Telecomunicações",
  "Gestão de Trânsito",
  "Gestão de Turismo",
  "Gestão em Serviços",
  "História",
  "História da Arte",
  "Horticultura",
  "Hotelaria",
  "Informática",
  "Informática para Negócios",
  "Instalações Elétricas",
  "Instrumentação Cirúrgica",
  "Inteligência Artificial",
  "Interiores e Decorações",
  "Internet das Coisas",
  "Investigação e Perícia Criminal",
  "Irrigação e Drenagem",
  "Jogos Digitais",
  "Jornalismo",
  "Laticínios",
  "Letras",
  "Logística",
  "Luteria",
  "Manufatura Avançada",
  "Manutenção Industrial",
  "Manutenção de Aeronaves",
  "Marketing",
  "Massoterapia",
  "Matemática",
  "Mecatrônica Automotiva",
  "Mecatrônica Industrial",
  "Mecânica",
  "Mecânica Automobilística",
  "Mecânica Industrial",
  "Mecânica de Precisão",
  "Mediação",
  "Medicina",
  "Medicina Veterinária",
  "Microeletrônica",
  "Mineração",
  "Ministério Pastoral",
  "Moda",
  "Multidisciplinar em Dependência Química",
  "Museologia",
  "Mídias Sociais",
  "Música",
  "Negócios Digitais",
  "Negócios Imobiliários",
  "Nutrição",
  "Odontologia",
  "Oftálmica",
  "Paisagismo",
  "Papel e Celulose",
  "Paramedicina",
  "Pedagogia",
  "Petróleo e Gás",
  "Pilotagem Profissional de Aeronaves",
  "Planejamento Logístico de Cargas",
  "Podologia",
  "Polímeros",
  "Política e Gestão Cultural",
  "Políticas Públicas",
  "Políticas e Estratégicas Públicas",
  "Processamento de Dados",
  "Processos Ambientais",
  "Processos Escolares",
  "Processos Gerenciais",
  "Processos Metalúrgicos",
  "Processos Químicos",
  "Produção Agropecuária",
  "Produção Agrícola",
  "Produção Audiovisual",
  "Produção Cervejeira",
  "Produção Cultural",
  "Produção Fonográfica",
  "Produção Gráfica",
  "Produção Industrial",
  "Produção Leiteira",
  "Produção Multimídia",
  "Produção Musical",
  "Produção Pesqueira",
  "Produção Publicitária",
  "Produção Sucroalcooleira",
  "Produção Têxtil",
  "Produção de Cacau e Chocolate",
  "Produção de Cachaça",
  "Produção de Fármacos",
  "Produção de Grãos",
  "Produção de Plástico",
  "Programa Especial de Formação Pedagógica",
  "Projeto de Estruturas Aeronáuticas",
  "Projetos Mecânicos",
  "Propaganda e Marketing",
  "Práticas Integrativas e Complementares",
  "Psicologia",
  "Publicidade e Propaganda",
  "Qualidade de Vida na Contemporaneidade",
  "Quiropraxia",
  "Química",
  "Radiologia",
  "Redes de Computadores",
  "Refrigeração e Climatização",
  "Relações Internacionais",
  "Relações Públicas",
  "Rochas Ornamentais",
  "Rádio, TV e Internet",
  "Saneamento Ambiental",
  "Saúde Coletiva",
  "Secretariado",
  "Secretariado Executivo",
  "Segunda Licenciatura",
  "Segurança Alimentar",
  "Segurança no Trabalho",
  "Service Design",
  "Serviço Social",
  "Silvicultura",
  "Sistema de Informação",
  "Sistemas Automotivos",
  "Sistemas Biomédicos",
  "Sistemas para Internet",
  "Soldagem",
  "Streaming Profissional",
  "Teatro",
  "Tecnologia Eletrônica",
  "Tecnologia Mecânica",
  "Tecnologia da Informação",
  "Tecnologia em Controle Ambiental",
  "Tecnologias Educacionais",
  "Telemática",
  "Teologia",
  "Terapia Ocupacional",
  "Terapias Integrativas e Complementares",
  "Toxicologia Ambiental",
  "Tradutor e Intérprete",
  "Transporte Terrestre",
  "Trânsito",
  "Turismo",
  "Tutoria de Educação a Distância",
  "Varejo Digital",
  "Visagismo e Terapias Capilares",
  "Viticultura e Enologia",
  "Zootecnia",
  "Óptica e Optometria",
]
